import api from './client';
import ApiError from './error';

const AssetService = {
  async updateAsset({ id, description }) {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }
        return Promise.reject(error);
      });

      return client.updateAsset(id, { description });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteAsset({ id }) {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }
        return Promise.reject(error);
      });

      return client.deleteAsset(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async finishAssetUpload({ id }) {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }
        return Promise.reject(error);
      });

      return client.finishAssetUpload(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default AssetService;
